import React from "react";
import { useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { refineAnswerSuggestionCall } from "../../../api/prompt-answer-suggestion";
import UseAnswerButton from "./UseAnswerButton";
import "../../taskpane.css";
import DisplayWarning from "../mui/snackbars/DisplayWarning";
import { LocalStorageHelper, LocalStorageKeys } from "../../../utils/local-storage-helper";

interface AnswerProps {
  answerHtml: string;
  conversation: any;
  onRefine: (conversation: any) => any;
}
//
const Answer: React.FC<AnswerProps> = ({ answerHtml, conversation, onRefine }) => {
  const [inputValue, setInputValue] = useState("");
  const [warning, setWarning] = useState(null);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const refineAnswerSuggestion = async (event) => {
    setInputValue("");
    const updatedConversation = {
      ...conversation,
      messages: conversation?.messages?.concat({ role: "user", content: inputValue }),
    };

    const params = {
      model: Office.context.roamingSettings.get("karlamail_model")?.id ?? LocalStorageHelper.getItem<any>(LocalStorageKeys.KARLA_MODEL)?.id,
      version: Office.context.roamingSettings.get("karlamail_model")?.version_id ?? LocalStorageHelper.getItem<any>(LocalStorageKeys.KARLA_MODEL)?.version_id,
      conversation_type: "mail",
      conversation: updatedConversation,
      auth: Office.context.roamingSettings.get("karla_access_token") ?? LocalStorageHelper.getItem(LocalStorageKeys.KARLA_ACCOUNT_TOKEN),
      org: Office.context.roamingSettings.get("karlamail_uid") ?? LocalStorageHelper.getItem(LocalStorageKeys.KARLA_UID),
      org_id: Office.context.roamingSettings.get("karlamail_org_id") ?? LocalStorageHelper.getItem(LocalStorageKeys.KARLA_ORG_ID),
      referrer: "outlook",
    };
    try {
      setWarning({ reason: "Refining message" });
      const refinedConversation: any = await refineAnswerSuggestionCall(params);
      onRefine(refinedConversation); // Callback function - Pass new conversation to root component
      setWarning({ reason: "Done!" });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <TextField
        id="refine-input-field"
        label="Refine suggestion"
        variant="outlined"
        value={inputValue}
        onChange={handleInputChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <div className="mui-icon-button-wrapper" onClick={refineAnswerSuggestion}>
                <IconButton type="submit">
                  <AutoFixHighIcon className="submit-refinement-button" />
                </IconButton>
              </div>
            </InputAdornment>
          ),
        }}
      />
      <div id="answer-text" className="answer-text" dangerouslySetInnerHTML={{ __html: answerHtml }} />
      <div id="use-answer-button-wrapper">
        <UseAnswerButton answerHtml={answerHtml} conversation={conversation}></UseAnswerButton>
      </div>
      {warning && (
        <DisplayWarning display_message={warning} snackbarHandleClose={() => setWarning(null)}></DisplayWarning>
      )}
    </>
  );
};

export default Answer;
